// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { BodyClassName } from 'view/common/body-class-name';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { generateThemeBranding } from '@atlassian/csm-colour-theme-generator';

const getLinkColorToken = (props: { theme: { color: string }; isCsm?: boolean }) => {
    if (FeatureGates.checkGate('csm_help_center_branding_updates') && props?.isCsm) {
        const generatedColors = generateThemeBranding(props.theme.color);
        return token('color.link', generatedColors.color900);
    }

    return token('color.link', props.theme.color);
};

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const GlobalStyled = styled(BodyClassName)<{ isCsm?: boolean }>`
    background-color: ${token('elevation.surface', colors.N0)};
    font: ${token(
        'font.body',
        'normal 400 14px/1.42857142857143 -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    )};
    a:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']),
    a:hover:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']) {
        color: ${(props) => getLinkColorToken(props)};
    }
    h1,
    h2 {
        letter-spacing: -0.001em;
    }
    /* Remove these root styles when design system adds AppProvider */
    :root {
        --ds-space-0: 0;
        --ds-space-025: 0.125rem;
        --ds-space-050: 0.25rem;
        --ds-space-075: 0.375rem;
        --ds-space-100: 0.5rem;
        --ds-space-150: 0.75rem;
        --ds-space-200: 1rem;
        --ds-space-250: 1.25rem;
        --ds-space-300: 1.5rem;
        --ds-space-400: 2rem;
        --ds-space-500: 2.5rem;
        --ds-space-600: 3rem;
        --ds-space-800: 4rem;
        --ds-space-1000: 5rem;
        --ds-font-family-monospace:
            'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier,
            monospace;
        --ds-font-family-sans:
            -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;
        --ds-font-size-050: 11px;
        --ds-font-size-075: 12px;
        --ds-font-size-100: 14px;
        --ds-font-size-200: 16px;
        --ds-font-size-300: 20px;
        --ds-font-size-400: 24px;
        --ds-font-size-500: 29px;
        --ds-font-size-600: 35px;
        --ds-font-weight-bold: 700;
        --ds-font-weight-medium: 500;
        --ds-font-weight-regular: 400;
        --ds-font-weight-semibold: 600;
        --ds-font-lineHeight-100: 1rem;
        --ds-font-lineHeight-200: 1.25rem;
        --ds-font-lineHeight-300: 1.5rem;
        --ds-font-lineHeight-400: 1.75rem;
        --ds-font-lineHeight-500: 2rem;
        --ds-font-lineHeight-600: 2.5rem;
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const NewGlobalBGColor = styled(BodyClassName)`
    background-color: ${token('elevation.surface', colors.N0)};
`;
